import { useEffect, useState } from "react";
import { AgentOSLayout } from "@/components/agent-os/AgentOSLayout";
import { apiFetch, Pill, Spinner } from "@/components/agent-os/shared";

export default function AgentOSAgents() {
    const [agents, setAgents] = useState(null);

    const load = () => apiFetch("/agents").then((r) => (r.ok ? r.json() : [])).then(setAgents);
    useEffect(() => { load(); }, []);

    const setStatus = async (agent, status) => {
        await apiFetch(`/agents/${agent.agent_id}`, { method: "PATCH", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ status }) });
        load();
    };

    return (
        <AgentOSLayout title="Agent Registry" subtitle="Five specialized AI employees are registered with least-privilege capabilities, provider configuration, approval requirements and usage limits.">
            {!agents ? <Spinner /> : (
                <div className="grid gap-6 xl:grid-cols-2" data-testid="agent-registry-list">
                    {agents.map((agent) => (
                        <article key={agent.agent_id} data-testid={`agent-card-${agent.agent_id}`} className="border border-ink/10 bg-ivory p-6 transition-colors hover:border-forest/30">
                            <div className="flex flex-wrap items-start justify-between gap-4">
                                <div>
                                    <p className="text-[10px] font-semibold uppercase tracking-[0.22em] text-champagne">{agent.role.replace(/_/g, " ")}</p>
                                    <h2 className="mt-2 font-serif text-2xl font-medium tracking-tight">{agent.name}</h2>
                                </div>
                                <Pill value={agent.status} />
                            </div>
                            <p className="mt-4 text-sm leading-relaxed text-ink/60">{agent.description}</p>
                            <div className="mt-6 grid gap-5 sm:grid-cols-2">
                                <div>
                                    <p className="text-[10px] font-semibold uppercase tracking-[0.18em] text-ink/40">Capabilities</p>
                                    <div className="mt-2 flex flex-wrap gap-1.5">{agent.capabilities.map((cap) => <span key={cap} className="bg-sand px-2 py-1 text-[10px] uppercase tracking-[0.12em] text-ink/55">{cap}</span>)}</div>
                                </div>
                                <div>
                                    <p className="text-[10px] font-semibold uppercase tracking-[0.18em] text-ink/40">Allowed tools</p>
                                    <div className="mt-2 flex flex-wrap gap-1.5">{agent.allowed_tools.map((tool) => <span key={tool} className="border border-forest/20 px-2 py-1 text-[10px] uppercase tracking-[0.12em] text-forest">{tool}</span>)}</div>
                                </div>
                            </div>
                            <div className="mt-6 border-t border-ink/10 pt-5 text-xs text-ink/55">
                                <p>Provider: {agent.provider_config.provider_id} · External AI: {agent.provider_config.external_ai_configured ? "configured" : "not configured"}</p>
                                <p className="mt-1">Daily cost limit: ${agent.cost_limits.daily} · Max steps: {agent.usage_limits.max_steps} · Memory write: {agent.memory_scope.write.join(", ")}</p>
                            </div>
                            <div className="mt-5 flex flex-wrap gap-2">
                                {["draft", "testing", "paused", "disabled"].filter((s) => s !== agent.status).map((status) => (
                                    <button key={status} type="button" data-testid={`agent-status-${agent.agent_id}-${status}`} onClick={() => setStatus(agent, status)} className="border border-ink/15 px-3 py-2 text-[10px] font-semibold uppercase tracking-[0.14em] text-ink/55 transition-colors hover:border-forest hover:text-forest">
                                        {status}
                                    </button>
                                ))}
                            </div>
                        </article>
                    ))}
                </div>
            )}
        </AgentOSLayout>
    );
}
